/** eslint-disable */
export default {
  configuracoes: {},
  notificacoes: [],
  filtro: '',
};
